export var isDefined = function (value) {
    return value !== undefined;
};
export function isOnChangeMulti(onChange, isMulti) {
    return onChange && isMulti ? true : false;
}
export function isOnChangeSingle(onChange, isMulti) {
    return onChange && isMulti ? false : true;
}
//# sourceMappingURL=helpers.js.map